<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
              ><div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div
          class="px-4 vx-row flex flex-wrap items-end gap-4"
          v-if="showFilters"
        >
          <div class="sm:w-1/2 sm:flex-grow-0 flex-grow">
            <vs-input
              v-validate="'required|alpha_spaces'"
              data-vv-as="field"
              name="PartyName"
              :label="$t('PartyName')"
              v-model="gridSearchData.name"
            />
          </div>
          <div class="">
            <vs-button
              type="filled"
              class="py-2"
              @click.prevent="FilterPartyName()"
            >
              {{ $t("SubmitFilter") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('SalesAssistantName') },
                { title: $t('AccountBalance') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 45%">
                  {{ row.partyFullName }}
                </td>
                <td style="width: 40%">
                  {{ Number(row.amount).toLocaleString() }}{{ $t("Rials") }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "CreditManagement_CreateInquiry_Index",
  components: {
    DataGrid,
  },
  data() {
    return {
      showFilters: false,
      gridDataSource: {
        type: "app",
        service: "Credits/api/PartiesQuery/account-info",
      },
      gridSearchData: {},
    };
  },
  methods: {
    FilterPartyName() {
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
